import React from 'react';
import { arrayOf } from 'prop-types';
import { isEmpty } from 'lodash';

import {
   DetailedRow,
   DetailedRowContent,
   SectionHeader,
} from './DetailedSearchRow';
import { historicalEndorsementType, endorsementHistoryType } from '../types';

const EndorsementHistoryCell = ({ history }) => {
   const endorsementYearsText = history.endorsementRangeYears.join(', ');

   return (
      <>
         <span>{history.endorsementTypeName}</span>
         <br />
         <span className="pr-subtext">{endorsementYearsText}</span>
      </>
   );
};

EndorsementHistoryCell.propTypes = {
   history: historicalEndorsementType.isRequired,
};

const EndorsementHistoryRow = ({ endorsementHistory }) => {
   return (
      <DetailedRowContent>
         <div className="col s12">
            {!isEmpty(endorsementHistory.current) && (
               <EndorsementHistoryCell history={endorsementHistory.current} />
            )}
         </div>
      </DetailedRowContent>
   );
};

EndorsementHistoryRow.propTypes = {
   endorsementHistory: endorsementHistoryType.isRequired,
};

const EndorsementHistory = ({ history }) => {
   const endorsementRows = history.map((h, i) => (
      <EndorsementHistoryRow key={i} endorsementHistory={h} />
   ));

   return (
      <DetailedRow>
         <SectionHeader label="Endorsement History" />
         {endorsementRows}
      </DetailedRow>
   );
};

EndorsementHistory.propTypes = {
   history: arrayOf(endorsementHistoryType).isRequired,
};

export default EndorsementHistory;
